import {
  FileText,
  ImageIcon,
  MessageSquare,
  Repeat2,
  ThumbsUp,
  Video,
} from "lucide-react";
import React, { useState, useCallback, useEffect } from "react";
import Button from "../../components/form/front/Button";
import Dropdown from "../../components/form/Dropdown";
import PostComposer from "../../components/sections/front/PostComposer";
import {
  CommentAdd,
  commentList,
  postFeedList,
  saveJob,
} from "../../services/postService";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useSocket } from "../../providers/SocketContext";
import { useSelector } from "react-redux";
import Avatar from "../../components/form/front/Avatar";

const Post = () => {
  const [jobs, setJobs] = useState([]);
  const [loadingComments, setLoadingComments] = useState({});
  const navigate = useNavigate();
  useEffect(() => {
    fetchPosts();
  }, []);
  useSocket("postAddResponse", (res) => {
    // console.log(res, "post");
    if (res?.data) {
      handleNewPost(res.data);
    }
  });

  useSocket("reactionAddResponse", (res) => {
    // console.log("reactionAddResponse socket response:", res);
    const postId = res?.data?.post;
    const stats = res?.data?.stats;

    if (!postId || !stats) return;

    setJobs((prev) =>
      prev.map((job) =>
        job.id === postId
          ? {
              ...job,
              like: stats.likeCount ?? job.like,
              stats: {
                ...job.stats,
                ...stats,
              },
            }
          : job,
      ),
    );
  });

  useSocket("commentAddResponse", (res) => {
    const comment = res?.data?.comment;
    const stats = res?.data?.stats?.stats;

    if (!comment) return;

    const postId = comment.postId;

    const formattedComment = {
      id: comment._id,
      text: comment.content,
      user: comment.userInfo?.firstName || "User",
      userInfo: comment.userInfo,
      replies: [],
      time: "Just now",
      like: 0,
      isLike: false,
    };

    setJobs((prev) =>
      prev.map((job) => {
        if (job.id !== postId) return job;

        const exists = job.comment.some((c) => c.id === comment._id);
        if (exists) return job;

        return {
          ...job,
          comment: [...job.comment, formattedComment],
          stats: {
            ...job.stats,
            ...stats,
          },
        };
      }),
    );
  });
  const { session } = useSelector((state) => state?.authProvider);

  const loggedinUser = session?.user || {};

  const fullName =
    [loggedinUser?.firstName, loggedinUser?.lastName]
      .filter(Boolean)
      .join(" ") || "User";

  const profileImage = loggedinUser?.image?.url || null;
  const fetchPosts = async () => {
    try {
      const res = await postFeedList({ page: 1 });

      const formattedPosts = res?.docs?.data?.map((post) => {
        const isReferral = !!post.postRefDetail;

        return {
          id: post._id,
          avatar: post.authorDetails?.image?.url || null,
          slug: isReferral ? post.postRefDetail?.slug : null,
          recruiterName: `${post.authorDetails?.firstName || ""} ${
            post.authorDetails?.lastName || ""
          }`,

          designation: "Member",

          companyName: isReferral
            ? `${post.postRefDetail?.authorDetails?.firstName || ""} ${
                post.postRefDetail?.authorDetails?.lastName || ""
              }`
            : "",

          jobPost:
            post.mediaGallery?.length > 0 ? post.mediaGallery[0]?.url : "",

          location: "",

          role: isReferral
            ? post.postRefDetail?.content?.en?.title
            : post.content?.en?.title,

          description: post.content?.en?.title || "",
          mediaGallery: post.mediaGallery || [],

          like: post.stats?.likeCount || 0,
          isLike: post.selfStatus?.like || false,
          comment: [],
          stats: post.stats,
          isReferral, // 🔥 important
        };
      });

      setJobs(formattedPosts);
    } catch (err) {
      console.error(err);
    }
  };
  const [showComment, setShowComment] = useState({});
  const [commentInputs, setCommentInputs] = useState({});
  const [showReply, setShowReply] = useState({});
  const handleNewPost = (postData) => {
    if (!postData) return;

    setJobs((prev) => {
      // prevent duplicate
      const exists = prev.some((job) => job.id === postData._id);
      if (exists) return prev;

      const isReferral = !!postData.postRefDetail;

      const formattedPost = {
        id: postData._id,
        avatar:
          postData.authorDetails?.image?.url ||
          postData.organization?.logo?.url ||
          null,
        slug: isReferral ? postData.postRefDetail?.slug : null,
        recruiterName: `${postData.authorDetails?.firstName || ""} ${
          postData.authorDetails?.lastName || ""
        }`,
        designation: "Member",
        companyName: isReferral
          ? `${postData.postRefDetail?.authorDetails?.firstName || ""} ${
              postData.postRefDetail?.authorDetails?.lastName || ""
            }`
          : "",
        jobPost: postData.mediaGallery?.[0]?.url || "",
        location: "",
        role: isReferral
          ? postData.postRefDetail?.content?.en?.title
          : postData.content?.en?.title,
        description: postData.content?.en?.title || "",
        mediaGallery: postData.mediaGallery || [],
        like: 0,
        isLike: false,
        comment: [],
        isReferral,
      };

      return [formattedPost, ...prev];
    });
  };
  // const handleLike = useCallback(
  //   async (id, referenceType = "post") => {
  //     setJobs((prev) =>
  //       prev.map((job) => {
  //         if (job.id !== id) return job;
  //         const updatedIsLike = !job.isLike;
  //         return {
  //           ...job,
  //           isLike: updatedIsLike,
  //           like: updatedIsLike ? job.like + 1 : job.like - 1,
  //         };
  //       }),
  //     );

  //     // Find the job to get its referenceId
  //     const job = jobs.find((j) => j.id === id);
  //     if (!job) return;

  //     const payload = {
  //       referenceId: job.id,
  //       referenceType, // "post" or "comment"
  //       reactionType: "like",
  //     };

  //     try {
  //       await saveJob(payload); // toggle like API
  //     } catch (err) {
  //       console.error("Failed to toggle like:", err);

  //       // revert UI if API fails
  //       setJobs((prev) =>
  //         prev.map((job) => {
  //           if (job.id !== id) return job;
  //           const revertedIsLike = !job.isLike;
  //           return {
  //             ...job,
  //             isLike: revertedIsLike,
  //             like: revertedIsLike ? job.like + 1 : job.like - 1,
  //           };
  //         }),
  //       );
  //     }
  //   },
  //   [jobs],
  // );

  const handleLike = async (id, referenceType = "post") => {
    let updatedIsLike = false;

    setJobs((prev) =>
      prev.map((job) => {
        if (job.id !== id) return job;

        updatedIsLike = !job.isLike;

        return {
          ...job,
          isLike: updatedIsLike,
          like: updatedIsLike ? job.like + 1 : job.like - 1,
        };
      }),
    );

    try {
      await saveJob({
        referenceId: id,
        referenceType,
        reactionType: "like",
      });
    } catch (err) {
      console.error("Failed to toggle like:", err);

      // revert UI
      setJobs((prev) =>
        prev.map((job) => {
          if (job.id !== id) return job;

          return {
            ...job,
            isLike: !updatedIsLike,
            like: updatedIsLike ? job.like - 1 : job.like + 1,
          };
        }),
      );
    }
  };
  const handleCommentLike = useCallback(
    async (postId, commentId) => {
      // Optimistic UI update
      setJobs((prev) =>
        prev.map((job) => {
          if (job.id !== postId) return job;
          const updatedComments = job.comment.map((c) =>
            c.id === commentId
              ? {
                  ...c,
                  isLike: !c.isLike,
                  like: (c.like || 0) + (c.isLike ? -1 : 1),
                }
              : c,
          );
          return { ...job, comment: updatedComments };
        }),
      );

      // TODO: call API if needed
      try {
        await saveJob({
          referenceId: commentId,
          referenceType: "comment",
          reactionType: "like",
        });
      } catch (err) {
        console.error("Failed comment like:", err);
      }
    },
    [jobs],
  );
  const handleToggleComment = useCallback(
    async (postId) => {
      setShowComment((prev) => ({
        ...prev,
        [postId]: !prev[postId],
      }));

      // Fetch comments only if opening and not already loaded
      const post = jobs.find((j) => j.id === postId);
      if (!post || post.comment.length > 0) return;

      setLoadingComments((prev) => ({ ...prev, [postId]: true }));

      try {
        const res = await commentList({ postId, limit: 20, page: 1 });
        const commentsData = res?.docs?.data?.map((c) => ({
          id: c._id,
          text: c.content,
          user:
            c.userInfo?._id === "YOUR_USER_ID"
              ? "You"
              : c.userInfo?.firstName || "User",
          userInfo: c.userInfo,
          replies:
            c.descendants?.map((r) => ({
              id: r._id,
              text: r.content,
              user: r.userInfo?.firstName || "User",
              userInfo: r.userInfo,
              time: "Just now", // optional, or parse from backend
              replies: [],
            })) || [],
          time: "Just now", // optional, or parse from backend
        }));

        setJobs((prev) =>
          prev.map((job) =>
            job.id === postId ? { ...job, comment: commentsData } : job,
          ),
        );
      } catch (err) {
        console.error("Failed to fetch comments:", err);
      } finally {
        setLoadingComments((prev) => ({ ...prev, [postId]: false }));
      }
    },
    [jobs],
  );

  const handleCommentChange = useCallback((id, value) => {
    setCommentInputs((prev) => ({
      ...prev,
      [id]: value,
    }));
  }, []);

  const handleAddComment = useCallback(
    async (id) => {
      const text = commentInputs[id]?.trim();
      if (!text) return;
      const tempId = `temp-${Date.now()}`;
      // Optimistically update UI
      const newComment = {
        id: tempId,
        text,
        user: "You",
        replies: [],
        time: "Just now",
      };

      setJobs((prev) =>
        prev.map((job) =>
          job.id === id
            ? { ...job, comment: [...job.comment, newComment] }
            : job,
        ),
      );

      setCommentInputs((prev) => ({ ...prev, [id]: "" }));

      // Prepare payload for API
      const payload = {
        postId: id,
        content: text,
        // parent: optional if it's a reply
      };

      try {
        const res = await CommentAdd(payload);
        setJobs((prev) =>
          prev.map((job) =>
            job.id === id
              ? {
                  ...job,
                  comment: job.comment.map((c) =>
                    c.id === tempId
                      ? {
                          id: res.data._id,
                          text: res.data.content,
                          user: "You",
                          userInfo: res.data.userInfo,
                          replies: [],
                          time: "Just now",
                        }
                      : c,
                  ),
                }
              : job,
          ),
        );
      } catch (err) {
        console.error("Failed to add comment:", err);
        setJobs((prev) =>
          prev.map((job) =>
            job.id === id
              ? {
                  ...job,
                  comment: job.comment.filter((c) => c.id !== tempId),
                }
              : job,
          ),
        );
      }
    },
    [commentInputs],
  );
  const [replyInputs, setReplyInputs] = useState({});

  const handleReplyChange = (commentId, value) => {
    setReplyInputs((prev) => ({ ...prev, [commentId]: value }));
  };

  const handleAddReply = async (postId, commentId) => {
    const text = replyInputs[commentId]?.trim();
    if (!text) return;

    // Optimistic UI
    setJobs((prev) =>
      prev.map((job) => {
        if (job.id !== postId) return job;
        const updatedComments = job.comment.map((c) =>
          c.id === commentId
            ? {
                ...c,
                replies: [
                  ...(c.replies || []),
                  { id: Date.now(), user: "You", text },
                ],
              }
            : c,
        );
        return { ...job, comment: updatedComments };
      }),
    );

    setReplyInputs((prev) => ({ ...prev, [commentId]: "" }));

    try {
      await CommentAdd({
        postId,
        content: text,
        parent: commentId,
      });
    } catch (err) {
      console.error("Failed to add reply:", err);
    }
  };
  const optionMenu = [
    {
      icon: "fa-regular fa-bookmark",
      name: "Save",
      click: () => alert("Saved Post"),
    },
    {
      icon: "fa-solid fa-link",
      name: "Copy Post Link",
      click: () => {},
    },
    {
      icon: "fa-regular fa-eye-slash",
      name: "Hide",
      click: () => {},
    },
    {
      icon: "fa-solid fa-code",
      name: "Embed this Post",
      click: () => {},
    },
  ];

  return (
    <div className="space-y-6">
      <PostComposer onPostCreated={handleNewPost} />

      {jobs.map((job) => (
        <div
          key={job.id}
          className="p-4 mb-6 bg-white rounded-xl shadow-md relative border-b-2 border-palatte2"
        >
          <div className="flex items-center gap-3">
            {/* <img
              src={job.avatar}
              alt="profile"
              className="w-12 h-12 rounded-full"
            /> */}
            <Avatar image={job.avatar} name={job.recruiterName} size={40} />

            <div className="flex-1">
              <h3 className="text-base font-semibold text-gray-800">
                {job.recruiterName}
              </h3>
              {/* <p className="text-xs font-medium text-gray-500">
                {job.designation}
              </p> */}
              {/* <p className="text-xs text-gray-400">4w •</p> */}
            </div>
            {/* <Dropdown
              data={optionMenu}
              xPlacement="bottomRight"
              buttonClasses="p-0 border-0"
              dropdownContainer="w-52"
              button={
                <div className="w-9 h-9 flex items-center justify-center rounded-full  text-gray-700 hover:bg-gray-100 cursor-pointer">
                  <i className="fa-solid fa-ellipsis text-xl text-palatte"></i>
                </div>
              }
            /> */}
          </div>

          <div className="mt-3 text-[13px] font-medium text-gray-700 whitespace-pre-line">
            {job.description}
          </div>
          {job.mediaGallery?.length > 0 && (
            <div className="mt-4">
              <img
                src={job.mediaGallery[0]?.url}
                alt="post-media"
                className="w-full max-h-[400px] object-cover rounded-xl"
              />
            </div>
          )}

          {job.isReferral && (
            <div className="mt-4 border border-gray-300 shadow-[0_0_8px_rgba(0,0,0,0.1)] rounded-xl p-3 flex items-center justify-between">
              <div className="flex items-center gap-3">
                {job.jobPost && (
                  <img
                    src={job.jobPost}
                    alt="company"
                    className="w-14 h-14 rounded"
                  />
                )}
                <div>
                  <h4 className="text-base font-semibold text-gray-800">
                    {job.role}
                  </h4>
                  <p className="text-xs text-gray-700 font-medium">
                    Job by {job.companyName}
                  </p>
                  <p className="text-xs text-gray-700 font-medium">
                    {job.location}
                  </p>
                </div>
              </div>
              <Button
                buttonLabel="View job"
                buttonFunction={() => navigate(`/job/${job.slug}`)}
                buttonClasses="bg-white text-palatte hover:bg-transparent hover:text-white px-4 h-8 rounded-full border-palatte/50 border hover:bg-palatte2 font-medium"
                buttonLabelClasses="text-sm"
              />
            </div>
          )}
          <div className="flex justify-between text-[13px] font-medium text-gray-500 py-3 border-b border-palatte2">
            <span>{job.like} Likes</span>
            <span>{job.stats?.commentCount || 0} comments</span>
          </div>

          <div className="flex justify-around text-sm font-medium text-gray-800 mt-3">
            <button
              onClick={() => handleLike(job.id)}
              className={`flex items-center gap-1 ${
                job.isLike ? "text-palatte font-medium" : ""
              }`}
            >
              <ThumbsUp size={16} />
              <span>Like</span>
            </button>

            <button
              onClick={() => handleToggleComment(job.id)}
              className="flex items-center gap-1"
            >
              <MessageSquare size={16} />
              Comment
            </button>
          </div>

          {showComment[job.id] && (
            <div className="mt-4">
              {loadingComments[job.id] ? (
                <p className="text-sm text-gray-400">Loading comments...</p>
              ) : (
                <>
                  <div className="flex items-center gap-2 mt-2">
                    <div className="w-10 h-10 rounded-full overflow-hidden">
                      {/* <img
                        src={job.avatar || "https://i.pravatar.cc/150"}
                        alt="user"
                        className="w-10 h-10"
                      /> */}
                      <Avatar image={profileImage} name={fullName} size={40} />
                    </div>

                    <input
                      type="text"
                      value={commentInputs[job.id] || ""}
                      onChange={(e) =>
                        handleCommentChange(job.id, e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleAddComment(job.id);
                        }
                      }}
                      placeholder="Write a comment..."
                      className="flex-1 px-3 py-2 h-10 text-sm rounded-full border-gray-300  shadow-[0_0_8px_rgba(0,0,0,0.1)] outline-none focus:outline-none focus:ring-0 focus:border-gray-300"
                    />
                  </div>

                  {job.comment.map((c) => (
                    <div key={c.id} className="mt-4">
                      <div className="flex gap-3">
                        {/* <img
                          src={
                            c.userInfo?.image?.url ||
                            "https://i.pravatar.cc/40?img=5"
                          }
                          alt={c.user}
                          className="w-8 h-8 rounded-full"
                        /> */}
                        <Avatar
                          image={c.userInfo?.image?.url}
                          name={c.user}
                          size={32}
                        />

                        <div className="flex-1">
                          <div className="bg-white px-3 py-2">
                            <div className="flex items-center justify-between gap-2">
                              <p className="text-sm font-semibold">{c.user}</p>
                              {/* <span className="text-xs text-gray-700">3h</span> */}
                              {c.createdAt && (
                                <span className="text-xs text-gray-400">
                                  {dayjs(c.createdAt).fromNow()}
                                </span>
                              )}
                            </div>
                            <p className="text-sm font-normal text-gray-500">
                              {c.text.length > 200
                                ? c.text.slice(0, 200) + " ...More"
                                : c.text}
                            </p>
                          </div>

                          {/* <div className="flex gap-4 text-xs font-medium text-gray-500 mt-1 ml-2">
                            <button>Like</button>
                            <button>
                              {c.replies?.length > 0
                                ? `Reply ${c.replies?.length}`
                                : "Reply"}
                            </button>
                            {c.createdAt && (
                              <span>{dayjs(c.createdAt).fromNow()}</span>
                            )}
                          </div> */}
                          <div className="flex gap-4 text-xs font-medium text-gray-500 mt-1 ml-2">
                            <button
                              onClick={() => handleCommentLike(job.id, c.id)}
                            >
                              {c.isLike ? "Liked" : "Like"}
                            </button>

                            <button
                              onClick={() =>
                                setShowReply((prev) => ({
                                  ...prev,
                                  [c.id]: !prev[c.id],
                                }))
                              }
                            >
                              {c.replies?.length > 0
                                ? `Reply ${c.replies.length}`
                                : "Reply"}
                            </button>
                            {c.createdAt && (
                              <span>{dayjs(c.createdAt).fromNow()}</span>
                            )}
                          </div>

                          {showReply[c.id] && (
                            <div className="ml-6 mt-2 flex items-center gap-2">
                              <input
                                type="text"
                                value={replyInputs[c.id] || ""}
                                onChange={(e) =>
                                  handleReplyChange(c.id, e.target.value)
                                }
                                onKeyDown={(e) =>
                                  e.key === "Enter" &&
                                  handleAddReply(job.id, c.id)
                                }
                                placeholder="Write a reply..."
                                className="flex-1 px-3 py-2 h-8 text-sm rounded-full border-gray-300 outline-none"
                              />
                            </div>
                          )}

                          {c.replies?.length > 0 && (
                            <div className="mt-3 ml-6 space-y-3">
                              {c.replies.map((r) => (
                                <div key={r.id} className="flex gap-3">
                                  {/* <img
                                    src={
                                      r.userInfo?.image?.url ||
                                      "https://i.pravatar.cc/35?img=7"
                                    }
                                    alt={r.user}
                                    className="w-7 h-7 rounded-full"
                                  /> */}

                                  <Avatar
                                    image={r.userInfo?.image?.url}
                                    name={r.user}
                                    size={28}
                                  />

                                  <div className="flex-1">
                                    <div className="bg-white px-3 py-2">
                                      <div className="flex items-center justify-between gap-2">
                                        <p className="text-sm font-semibold">
                                          {r.user}
                                        </p>
                                        {/* <span className="text-xs text-gray-700">
                                          15m
                                        </span> */}
                                        {r.createdAt && (
                                          <span className="text-xs text-gray-400">
                                            {dayjs(r.createdAt).fromNow()}
                                          </span>
                                        )}
                                      </div>
                                      <p className="text-sm font-normal text-gray-500">
                                        {r.text.length > 200
                                          ? r.text.slice(0, 200) + " ...More"
                                          : r.text}
                                      </p>
                                    </div>

                                    <div className="flex gap-4 text-xs font-medium text-gray-500 mt-1 ml-2">
                                      <button>Like</button>
                                      <button>
                                        {r.replies?.length > 0
                                          ? `Reply ${r.replies?.length}`
                                          : "Reply"}
                                      </button>
                                      {r.createdAt && (
                                        <span>
                                          {dayjs(r.createdAt).fromNow()}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Post;
